import { useEffect } from "react";

import { Nav, Footer } from "../components/Nav";
import cover from "../images/WebCrack/WebCrack Cover.png";
import poster from "../images/WebCrack/WebcCrack Poster.png";
import {
  ProjectInfo,
  TextSection,
  MoreSection,
} from "../components/ProjectDetails";

export default function WebCrack() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  return (
    <>
      <header id="project-cover">
        <Nav color="white" />

        <h1>WebCrack</h1>
        <p>
          2024 Hack for Humanity Finalist Project
          <br />
          Chrome extension for detecting potential bias in articles for ESL
          readers.
        </p>

        <img id="cover" src={cover} alt="WebCrack Cover" />
      </header>

      <main id="project-detail-main">
        <ProjectInfo
          role={["Full-stack Developer"]}
          team={["6 Members"]}
          toolkit={["React", "ChatGPT API", "LangChain"]}
          duration="24 Hours (2024)"
        />

        <TextSection type="callout" header="project overview" title="The Goal">
          <p>
            WebCrack is a Chrome extension designed to detect potential bias in
            online articles by analyzing the background of the source and
            author. It also offers features like estimating read time and
            suggesting additional relevant articles to enhance the reading
            experience.
          </p>
          <p>
            This project was created for the 2024 Hack for Humanity with the
            goal of empowering ESL (English as a Second Language) individuals.
            By providing a tool that simplifies the process of consuming
            information online, we aim to help users recognize and navigate
            potential biases and misinformation more effectively in their daily
            lives.
          </p>
          <a
            href="https://github.com/tsaichenlin/WebCrackExtension"
            className="primary-button"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginRight: "1rem" }}
          >
            View Code on GitHub
          </a>
          <a
            href="https://devpost.com/software/webcrack"
            target="_blank"
            rel="noopener noreferrer"
            className="primary-button"
          >
            View Project on Devpost
          </a>
        </TextSection>

        <TextSection
          type="normal-text"
          header="My Role"
          title="Key Contributions"
        >
          <ul>
            <li>
              Led the team in ideation, project conceptualization, and task
              distribution.
            </li>
            <li>Developed the front-end of the Chrome extension.</li>
            <li>
              Integrated back-end functionality to ensure smooth compatibility
              within the Chrome environment.
            </li>
          </ul>
        </TextSection>

        <TextSection
          type="callout"
          header="Final Product"
          title="WebCrack Extension Screenshot"
        >
          <img src={poster} alt="WebCrack Poster" />
        </TextSection>
      </main>
      <MoreSection exclude={["webcrack"]} />

      <Footer />
    </>
  );
}
